<script setup>
import { defineProps, defineEmits, watch } from "vue";

const props = defineProps({
  modelValue: Array,
});

const emit = defineEmits(["update:modelValue"]);

watch(
  () => props.modelValue,
  (newVal) => {
    newVal.forEach((alert, index) => {
      if (alert.timeout) {
        setTimeout(() => {
          newVal.splice(index, 1);
          emit("update:modelValue", newVal);
        }, alert.timeout * 1000);
      }
    });
  },
  { deep: true }
);
</script>

<template>
  <v-alert
    class="ma-2"
    v-for="alert in props.modelValue"
    :key="alert"
    :type="alert.type"
    :closable="alert.closable"
    density="compact"
  >
    <v-alert-title v-if="alert.title">{{ alert.title }}</v-alert-title>
    {{ alert.message }}
  </v-alert>
</template>
